import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {SettingsParkingPassesService} from '../../../services/settings-parking-passes.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'settings-parking-passes-rules-list',
    templateUrl: './settings-parking-passes-rules-list.component.html',
    styleUrls: ['./settings-parking-passes-rules-list.component.scss']
})
export class SettingsParkingPassesRulesListComponent {

    constructor(
        public urlService: UrlService,
        public settingsParkingPassesService: SettingsParkingPassesService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.settingsParkingPassesService.parkingPassesData.rules.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    toggleCheck(selectedItem): void {
        const checked = selectedItem.checked;
        this.uncheckItem();
        this.settingsParkingPassesService.emptyNotificationArrays();
        if (checked && this.settingsParkingPassesService.selectedItemData) {
            this.settingsParkingPassesService.toggleDetailedView(null, false);
        } else {
            selectedItem.checked = true;
            this.settingsParkingPassesService.selectedItemData = null;
            setTimeout(() => {
                this.settingsParkingPassesService.toggleDetailedView(selectedItem, true);
                this.settingsParkingPassesService.formatNotificationSettingsRoles();
            });
        }
    }

    uncheckItem(): void {
        this.settingsParkingPassesService.parkingPassesData.rules.data.forEach((item) => item.checked = false);
    }

    deleteAmenity(item, event): void {
        event.stopPropagation();
        this.settingsParkingPassesService.deleteParkingRule(item);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/settings-parking-passes-rules-list/settings-parking-passes-rules-list.component.ts